// extracted by mini-css-extract-plugin
export default {"options":"search-results-list-options_options__ENw1t","opener":"search-results-list-options_opener__lApLa","icon":"search-results-list-options_icon__vl0mT"};